import React from 'react';

import { Chip, Tooltip } from '@mui/material';

export default function SampleDataChip() {
  return (
    <Tooltip title="Made-up records until this list reads Salesforce.">
      <Chip color="warning" label="Sample data" size="small" variant="outlined" />
    </Tooltip>
  );
}
